
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/loyalty/join/joinPromotion",
      function () {
        return require("private-next-pages/loyalty/join/joinPromotion/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/loyalty/join/joinPromotion"])
      });
    }
  